import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9f96e00c")

_pushScopeId("data-v-9f96e00c")
const _hoisted_1 = {
  key: 2,
  class: "funicebreaker__game flex items-center justify-center"
}
const _hoisted_2 = {
  key: 1,
  class: "color-white"
}
const _hoisted_3 = { class: "flex flex-column funicebreaker__content" }
const _hoisted_4 = { class: "flex flex-column justify-center items-center funicebreaker__phase" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LanguageSelection = _resolveComponent("LanguageSelection")!
  const _component_FunIceBreakerGameEnded = _resolveComponent("FunIceBreakerGameEnded")!
  const _component_GameLogout = _resolveComponent("GameLogout")!
  const _component_IconAttribute = _resolveComponent("IconAttribute")!
  const _component_SoundMuting = _resolveComponent("SoundMuting")!
  const _component_AddAdmin = _resolveComponent("AddAdmin")!
  const _component_LogoSpinner = _resolveComponent("LogoSpinner")!
  const _component_FunIceBreakerJoinGame = _resolveComponent("FunIceBreakerJoinGame")!
  const _component_FunIceBreakerLeftNavigation = _resolveComponent("FunIceBreakerLeftNavigation")!
  const _component_FunIceBreakerTopNav = _resolveComponent("FunIceBreakerTopNav")!
  const _component_FunIceBreakerInstructionGuy = _resolveComponent("FunIceBreakerInstructionGuy")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_LanguageSelection, { class: "funicebreaker__language" }),
    (_ctx.currentGame.gameEnded)
      ? (_openBlock(), _createBlock(_component_FunIceBreakerGameEnded, {
          key: 0,
          results: _ctx.currentGame.players,
          "is-admin": _ctx.currentPlayer?.admin && _ctx.currentPlayer?.email
        }, null, 8, ["results", "is-admin"]))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode("div", {
            class: ["funicebreaker__options", { 'funicebreaker__options--visible': _ctx.optionsVisible }]
          }, [
            _createVNode(_component_GameLogout, { class: "my2" })
          ], 2),
          _createVNode(_component_IconAttribute, { white: true }),
          _createVNode(_component_SoundMuting, { class: "funicebreaker__sound" }),
          (_ctx.currentPlayer?.admin)
            ? (_openBlock(), _createBlock(_component_AddAdmin, {
                key: 0,
                players: _ctx.currentGame?.players,
                class: "funicebreaker__add-admin",
                onChange: _ctx.handleAddAdmin
              }, null, 8, ["players", "onChange"]))
            : _createCommentVNode("", true),
          (_ctx.gameLoading)
            ? (_openBlock(), _createBlock(_component_LogoSpinner, { key: 1 }))
            : (_openBlock(), _createBlock("div", _hoisted_1, [
                (_ctx.currentGame && !_ctx.currentGame.gameEnded && _ctx.showJoinGame)
                  ? (_openBlock(), _createBlock(_component_FunIceBreakerJoinGame, {
                      key: 0,
                      players: _ctx.currentGame.players,
                      avatars: _ctx.currentGame.avatars,
                      "join-loading": _ctx.joinLoading,
                      onJoin: _ctx.handleJoinGame
                    }, null, 8, ["players", "avatars", "join-loading", "onJoin"]))
                  : (_ctx.currentGame && !_ctx.currentGame.gameEnded && !_ctx.playerHasJoinedTheGame)
                    ? (_openBlock(), _createBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('funTeamBidding.gameAlreadyStarted')), 1))
                    : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                        _createVNode(_component_FunIceBreakerLeftNavigation, {
                          class: "funicebreaker__nav",
                          game: _ctx.currentGame
                        }, null, 8, ["game"]),
                        _createVNode("div", _hoisted_3, [
                          (_ctx.currentGame.phase !== 'WELCOME')
                            ? (_openBlock(), _createBlock(_component_FunIceBreakerTopNav, {
                                key: 0,
                                phase: _ctx.currentGame.phase,
                                "questions-left": _ctx.currentGame.noOfQuestionsLeft,
                                class: "funicebreaker__top-nav"
                              }, null, 8, ["phase", "questions-left"]))
                            : _createCommentVNode("", true),
                          _createVNode("div", _hoisted_4, [
                            (_ctx.condition)
                              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.funIceBreakerPhase), {
                                  key: 0,
                                  game: _ctx.currentGame,
                                  user: _ctx.user,
                                  "start-game": _ctx.startGame,
                                  "cancel-game": _ctx.cancelGame,
                                  "show-start-game-button": _ctx.showStartGameButton,
                                  instructions: _ctx.instructions
                                }, null, 8, ["game", "user", "start-game", "cancel-game", "show-start-game-button", "instructions"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createVNode(_component_FunIceBreakerInstructionGuy, {
                          class: "funicebreaker__instruction-guy",
                          phase: _ctx.currentGame.phase,
                          "question-type": _ctx.currentGame.activeQuestion?.type
                        }, null, 8, ["phase", "question-type"])
                      ], 64))
              ]))
        ], 64))
  ], 64))
})